import React from 'react';
import { useSelector } from 'react-redux';

import { Col } from '@amzn/stencil-react-components/layout';
import { H4 } from '@amzn/stencil-react-components/text';
import { TabBar, TabSwitcher, TabPanel } from '@amzn/stencil-react-components/tabs';
import { Text } from '@amzn/stencil-react-components/text';

import {
  CONTENT_TOOLBAR_OPTIONS,
  EDITOR_TABS,
  STYLE_TOOLBAR_OPTIONS,
  TAB_GROUP,
} from '../../constants/editorConfig';
import BorderedView from '../common/BorderedView';
import { createContentSelector, templateContentSelector } from '../../selectors/selectors';
import RichTextEditor from '../molecules/RichTextEditor';
import { FormattedMessage } from 'react-intl';

export const EditorPanel = () => {
  const { selectedContentId } = useSelector(createContentSelector);
  const contentElements = useSelector(templateContentSelector);

  const selectedTab = 'Content';
  const tabs = EDITOR_TABS;
  const tabGroup = TAB_GROUP;
  const richTextContent =
    contentElements?.filter(contentElement => contentElement.id === selectedContentId)?.[0]
      ?.content ?? '';
  return (
    <BorderedView width="55%" padding="10px">
      <Col height={'100%'} gridGap="S200">
        <H4>
          <FormattedMessage id="app.editorPanel.label.property" defaultMessage="Properties" />
        </H4>
        <Col gridGap="S500">
          <TabBar tabs={tabs} selectedTab={selectedTab} tabGroup={tabGroup} />

          <TabSwitcher selectedTab={selectedTab} tabGroup={tabGroup}>
            {selectedTab === tabs[0] && (
              <TabPanel value={tabs[0]}>
                <Col width={'100%'}>
                  {selectedContentId === '' ? (
                    <Col alignItems="center" flex={1}>
                      <Text color="gray">
                        <FormattedMessage id="app.editorPanel.label.selectContent" />
                      </Text>
                    </Col>
                  ) : null}
                  {selectedContentId !== '' ? (
                    <RichTextEditor value={richTextContent} toolbar={CONTENT_TOOLBAR_OPTIONS} />
                  ) : null}
                </Col>
              </TabPanel>
            )}
            )
            {selectedTab === tabs[1] && (
              <TabPanel value={tabs[1]}>
                <Col width={'100%'}>
                  {selectedContentId === '' && (
                    <Col alignItems="center" flex={1}>
                      <Text color="gray">
                        <FormattedMessage id="app.editorPanel.label.selectContent" />
                      </Text>
                    </Col>
                  )}
                  {selectedContentId !== '' && (
                    <RichTextEditor value={richTextContent} toolbar={STYLE_TOOLBAR_OPTIONS} />
                  )}
                </Col>
              </TabPanel>
            )}
            {selectedTab === tabs[2] && (
              <TabPanel value={tabs[2]}>
                <Text>
                  <FormattedMessage id="app.editorPanel.label.layout" defaultMessage="Layout" />
                </Text>
              </TabPanel>
            )}
          </TabSwitcher>
        </Col>
      </Col>
    </BorderedView>
  );
};
